/**
 * KeybindingsTooltipContent — static reference list of JxCodeEditor's default CM6 shortcuts
 * (basicSetup: defaultKeymap, historyKeymap, searchKeymap, foldKeymap, completionKeymap,
 * closeBracketsKeymap). Purely informational, no state.
 * 'Mod' entries are resolved to the actual key (Ctrl / Cmd) for the current OS at render time —
 * CodeMirror itself does the same runtime substitution internally for its own keymaps.
 */

/** Detects macOS so 'Mod' can be resolved to 'Cmd' instead of 'Ctrl'. */
const isMac = () => {
    // userAgentData is the modern, non-deprecated source where available (Chromium)
    const platform = navigator.userAgentData?.platform ?? navigator.platform ?? navigator.userAgent;
    return /mac/i.test(platform);
};

const MOD_KEY = isMac() ? 'Cmd' : 'Ctrl';

/** Replaces 'Mod' with the resolved key for the current OS, leaves everything else untouched. */
const resolveKeys = (keys) => keys.replace(/\bMod\b/g, MOD_KEY);

const GROUPS = [
    {
        title: 'Editing',
        items: [
            ['Mod-z / Mod-Shift-z', 'Undo / redo'],
            ['Mod-a', 'Select all'],
            ['Alt-Left/Right', 'Cursor per woord'],
            ['Mod-Left/Right', 'Naar begin/eind regel'],
            ['Mod-Up/Down', 'Naar begin/eind document'],
            ['Mod-Backspace/Delete', 'Woord verwijderen'],
            ['Mod-Shift-k', 'Regel verwijderen'],
            ['Alt-Up/Down', 'Regel verplaatsen'],
            ['Shift-Alt-Up/Down', 'Regel kopiëren'],
            ['Tab / Shift-Tab', 'Indent / dedent'],
        ],
    },
    {
        title: 'Selectie',
        items: [
            ['Alt + slepen', 'Block/column select'],
            ['Mod-d', 'Volgende occurrence toevoegen aan selectie'],
        ],
    },
    {
        title: 'Comments',
        items: [['Mod-/', 'Toggle line comment']],
    },
    {
        title: 'Zoeken',
        items: [
            ['Mod-f', 'Zoeken'],
            ['Mod-g / Shift-Mod-g', 'Volgende / vorige match'],
        ],
    },
    {
        title: 'Fold',
        items: [
            ['Ctrl-Shift-[ / ]', 'Fold / unfold'],
            ['Ctrl-Alt-[', 'Fold all'],
        ],
    },
    {
        title: 'Autocomplete',
        items: [
            ['Ctrl-Space', 'Trigger completion'],
            ['Enter / Tab', 'Accepteren'],
            ['Escape', 'Sluiten'],
        ],
    },
];

/** Renders the grouped shortcuts list — passed as JxTooltip's `title` (ReactNode). */
export default function KeybindingsTooltipContent() {
    return (
        <div className="jx-code-editor-kb">
            {GROUPS.map((group) => (
                <div key={group.title} className="jx-code-editor-kb-group">
                    <div className="jx-code-editor-kb-group-title">{group.title}</div>
                    {group.items.map(([keys, desc]) => (
                        <div key={keys} className="jx-code-editor-kb-row">
                            <span className="jx-code-editor-kb-keys">{resolveKeys(keys)}</span>
                            <span className="jx-code-editor-kb-desc">{desc}</span>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
